export default __webpack_public_path__ + "static/media/face.3152e85d.png";